import { GridColDef, GridInputRowSelectionModel, GridRowsProp, GridValidRowModel } from "@mui/x-data-grid";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import GenericPromises from "../../../../api/GenericPromises";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";
import { useFiles } from "../../../../hooks/useFiles";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useCurrencies } from "../../../../hooks/useCurrencies";
import { Supplier, SupplierLocation } from '../../../../interfaces/Purchases/Catalogs/suppliers';
import { Company, CompanyBankAccount, CompanyLocation } from "../../../../interfaces/Security/companies";
import { SupplierBankAccount } from "../../../../interfaces/Purchases/Catalogs/supplierBankAccounts";
import { PaymentMethod } from "../../../../interfaces/Sales/Catalogs/paymentMethods";
import { Currency } from "../../../../interfaces/Commons/currencies";
import { Menuitem } from "../../../../interfaces/Security/menu";
import { SubmitHandler, useForm } from "react-hook-form";
import { Payment, PaymentDetail } from "../../../../interfaces/Purchases/Payments/payments";
import Swal from "sweetalert2";
import { CFDI } from "../../../../interfaces/Sales/Catalogs/CFDIs";
import { File } from "../../../../interfaces/Commons/files";
import { Header } from "../../../../components/Header";
import { Backdrop, Box, CircularProgress, Skeleton, useTheme } from "@mui/material";
import { DialogEntity } from "../../../../components/Dialogs/DialogEntity";
import { ConfrimDialogPayment } from './confirmDialog';
import { StampingPayment } from "../commons/stamping";
import DialogPayments from "./tabsDetail";
import { PaymentsPDF } from "../../../../reports/paymentsPDF/PaymentsPDF";
import { BankAccount } from "../../../../interfaces/Commons/bankAccounts";
import { TableApplyPayment } from "./Table/table";
import { TableCurrencyBankAccounts } from "./TableCurrencyBankAccounts/table";
import { MyTableCurrencyBanks } from "./TableCurrencyBankAccounts/columns";
import { useFormulaEvaluator } from "../../../../hooks/useFormulaEvaluator";
import { HeaderPayment } from "./HeaderPayment/HeaderPayment";
import { PaymentForm } from "./PaymentForm/PaymentForm";
import { usePdf } from "../../../../hooks/usePdf";
import { Consecutive } from "../../../../interfaces/Commons/consecutives";

export type DialogPaymentProps = {
  rows: readonly GridValidRowModel[],
  businessName: string,
  supplier_id: number,
  selectedRows?: GridRowsProp,
  setSelectedRows?: Dispatch<SetStateAction<readonly GridValidRowModel[]>>,
  setDialogPayment: Dispatch<SetStateAction<boolean>>,
  setClickedButtonGoBack: Dispatch<SetStateAction<boolean>>,
  myParentColumns: GridColDef<PaymentDetail>[],
  myParentPreferences: {},
}

export const DialogPayment = ({
  rows,
  supplier_id,
  businessName,
  selectedRows,
  setSelectedRows,
  setDialogPayment,
  setClickedButtonGoBack,
  myParentColumns,
  myParentPreferences,
}: DialogPaymentProps) => {
  const [t] = useTranslation("global");
  const { GenericGetResource, GenericPostResource, GenericGetResourceGeneric, GenericGetReport, GenericPost, GenericPutResource } = GenericPromises();
  const { SnackbarComponent, showSnackBar } = useSnackBar();
  const { GetFiles } = useFiles();
  const { GetResourceByUrl } = usePermissions();
  const { GetExchangeRateFromCurrencyCode, GetOperatorToGetDivisa } = useCurrencies();
  const theme = useTheme();
  const [isLoadedExchangeRate, setIsLoadedExchangeRate] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const [loadingPost, setLoadingPost] = useState(false);
  const [hasErrorPost, setHasErrorPost] = useState(false);
  const [hasPositiveDifference, setHasPositiveDifference] = useState(false);
  const [dialogConfirmApplyPayment, setDialogConfirmApplyPayment] = useState(false);
  const [hasAdvanceSalesInvoice, setHasAdvanceSalesInvoice] = useState(false);
  const [hasExchangeRate, setHasExchangeRate] = useState(false);
  const [hasCommissionAmount, setHasCommissionAmount] = useState(false);
  const [commissionParsed, setCommissionParsed] = useState(0);
  const [myConsecutive, setMyConsecutive] = useState<Consecutive>();
  const [mySupplierLocal, setMySupplierLocal] = useState<Supplier>();
  const [myCompanyLocal, setMyCompanyLocal] = useState<Company>();
  const [preSelectedRows, setPreSelectedRows] = useState<GridInputRowSelectionModel>();
  const [defaultSupplierBankAccount, setDefaultSupplierBankAccount] = useState<SupplierBankAccount>();
  const [defaultCompanyBankAccount, setDefaultCompanyBankAccount] = useState<CompanyBankAccount>();
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState<PaymentMethod>();
  const [comboSupplierBankAccounts, setComboSupplierBankAccounts] = useState<SupplierBankAccount[]>([]);
  const [comboCompanyBankAccounts, setComboCompanyBankAccounts] = useState<CompanyBankAccount[]>([]);
  const [comboPaymentMethods, setComboPaymentMethods] = useState<PaymentMethod[]>([]);
  const [comboCurrencies, setComboCurrencies] = useState<Currency[]>([]);
  const [comboCommissionCurrencies, setComboCommissionCurrencies] = useState<Currency[]>([]);
  const [mySelectedRows, setMySelectedRows] = useState<GridRowsProp>([]);
  const [comboSuppliersLocations, setComboSuppliersLocations] = useState<SupplierLocation[]>([])
  const [defaultSupplierLocation, setDefaultSupplierLocation] = useState<SupplierLocation>();
  const [resourceFiscalSignature, setResourceFiscalSignature] = useState<Menuitem>();
  const [fiscalXML, setFiscalXML] = useState<File>();
  const [fiscalQr, setFiscalQr] = useState<File>();
  const [isEdit, setIsEdit] = useState(false);
  const [isLoadingCurrenciesValues, setIsLoadingCurrenciesValues] = useState(false);
  const [currencySupplier, setCurrencySupplier] = useState<Currency | undefined>();
  const [commissionCurrency, setCommissionCurrency] = useState<Currency | undefined>();
  const [exchangeRate, setExchangeRate] = useState(1);
  const { generatePDF } = PaymentsPDF();
  const [rowsCompanyBalance, setRowsCompanyBalance] = useState<MyTableCurrencyBanks[]>([{ balance: 0, balancePay: 0, balanceFree: 0, currency_id: 0, currency_code: "" }]);
  const [companyBalance, setCompanyBalance] = useState({ balance: 0, currency_id: 0, currency_code: "" })
  const [comboBankAccountsGeneral, setComboBankAccountsGeneral] = useState<BankAccount[]>([]);
  const [defaultBankAccountFinal, setDefaultBankAccountFinal] = useState<BankAccount>();
  const [paymentLocal, setPaymentLocal] = useState<Payment>();
  const [parameters, setParameters] = useState();
  const { fetchParameters } = useFormulaEvaluator();
  const { SavePdf } = usePdf();

  const {
    handleSubmit,
    control,
    formState: { errors },
    getValues,
    setValue,
    trigger,
    reset,
  } = useForm<Payment>({
    defaultValues: {
      total_amount: 0,
      selected_amount: 0,
      difference_amount: 0,
      currency_id: undefined
    }
  });
  const onSubmit: SubmitHandler<Payment> = (data) => onPost(data);

  const onPost = (data: Payment) => {
    trigger()
      .then(async (responseTrigger) => {
        let myPaymentsDetails = mySelectedRows.map(item => {
          if (!item.product_service_key) {
            return item.payment_detail_id;
          }
        }).filter(id => id !== undefined && id !== null);
        let myAdvanceInvoices = mySelectedRows.map(item => {
          if (item.product_service_key) {
            return item.payment_detail_id;
          }
        }).filter(id => id !== undefined && id !== null);

        if (responseTrigger) {
          setIsEdit(true);
          setLoadingPost(true);
          setHasErrorPost(false);

          const paymentDetailsMap = mySelectedRows.reduce((map, detail) => {
            map[detail.payment_detail_id] = detail.payment_deadline;
            return map;
          }, {} as { [key: number]: Date | null | undefined });

          const sortedPaymentsDetails = myPaymentsDetails.sort((a, b) => {
            const dateStrA = paymentDetailsMap[a];
            const dateStrB = paymentDetailsMap[b];

            if (dateStrA === null || dateStrA === undefined) {
              return 1;
            }
            if (dateStrB === null || dateStrB === undefined) {
              return -1;
            }

            const dateA = new Date(dateStrA);
            const dateB = new Date(dateStrB);

            return dateA.getTime() - dateB.getTime();
          });

          let myCurrency = comboCurrencies.find((item) => item.currency_code === currencySupplier?.currency_code);
          const responseSupplierLocations: SupplierLocation[] = await GenericGetResource(`/supplierlocations/bysupplierid/${mySupplierLocal?.supplier_id}`)
            .then(responseInterSupplier => {
              return responseInterSupplier.data.data;
            })
            .catch((error) => showSnackBar(error.message, 'error'));
          let mySupplierLocation;
          if (defaultSupplierLocation?.supplier_location_id && defaultSupplierLocation?.supplier_location_id > 0) {
            mySupplierLocation = defaultSupplierLocation;
          }
          else {
            mySupplierLocation = responseSupplierLocations.find(item => item.fiscal_address === true);
          }

          const responseCompanyLocations: CompanyLocation[] = await GenericGetResourceGeneric(`/companylocations`, `/gcompanylocations`)
            .then(responseInterCompany => {
              return responseInterCompany.data.data;
            })
            .catch((error) => showSnackBar(error.message, 'error'));
          const myCompanyLocation = responseCompanyLocations.find(item => item.main_location === true);

          const responseConsecutive = await GenericGetResource(`/consecutives/getandupdate/byConsecutiveId/${myConsecutive?.consecutive_id ?? 0}`)
            .catch((error) => showSnackBar(error.message, 'error'));

          const responseCFDIs: CFDI[] = await GenericGetResource(`/cfdi`)
            .then((responseInterCFDIs) => responseInterCFDIs.data.data)
            .catch((error) => showSnackBar(error.message, 'error'));
          const myCFDI = await responseCFDIs.find((item) => item.code === "CP01")

          let mySupplierBankAccount = comboSupplierBankAccounts.find((item) => item.supplier_bank_account_id === data.supplier_bank_account_id);
          let myCompanyBankAccount = comboCompanyBankAccounts.find((item) => item.company_bank_account_id === data.company_bank_account_id);
          let myPaymentMethod = comboPaymentMethods.find((item) => item.payment_method_id === data.payment_method_id);
          let myIntermediaryBank = comboBankAccountsGeneral.find((element) => element.bank_account_id === data.intermediary_bank_account_id)

          let totalAmount = parseFloat(data.total_amount?.toString() ?? "0.00");
          if (hasExchangeRate) {
            let operator = GetOperatorToGetDivisa(myCurrency?.currency_code ?? "", myCompanyBankAccount?.currency_code ?? '');
            if (operator === "multiply") {
              totalAmount = totalAmount * exchangeRate;
            }
            else if (operator === "divide") {
              totalAmount = totalAmount / exchangeRate;
            }
          }

          totalAmount = parseFloat(totalAmount.toFixed(6));
          let myData = {
            payment_name: responseConsecutive.data.data[0].Consecutive ?? (data.payment_name ?? null),
            consecutive_id: myConsecutive?.consecutive_id ?? (data.consecutive_id ?? null),
            payment_date: data.payment_date ? (data.payment_date instanceof Date ? data.payment_date : new Date(data.payment_date)).toDateString() : null,
            signing_date: data.signing_date ?? null,
            supplier_id: mySupplierLocal?.supplier_id ?? (data.supplier_id ?? null),
            supplier_business_name: mySupplierLocation?.business_name ?? (data.supplier_business_name ?? null),
            supplier_comercial_name: mySupplierLocal?.comercial_name ?? (data.supplier_comercial_name ?? null),
            supplier_rfc: mySupplierLocation?.supplier_rfc ?? (data.supplier_rfc ?? null),
            payment_method_id: myPaymentMethod?.payment_method_id ?? (data.payment_method_id ?? null),
            payment_method_name: myPaymentMethod?.name ?? (data.payment_method_name ?? null),
            payment_method_code: myPaymentMethod?.code ?? (data.payment_method_code ?? null),
            payment_method_description: myPaymentMethod?.description ?? (data.payment_method_description ?? null),
            supplier_tax_regime_id: mySupplierLocal?.tax_regime_id ?? (data.supplier_tax_regime_id ?? null),
            supplier_tax_regime_code: mySupplierLocal?.tax_regime_code ?? (data.supplier_tax_regime_code ?? null),
            supplier_tax_regime_description: mySupplierLocal?.tax_regime_description ?? (data.supplier_tax_regime_description ?? null),
            cfdi_id: myCFDI?.cfdi_id ?? (data.cfdi_id ?? null),
            cfdi_code: myCFDI?.code ?? (data.cfdi_code ?? null),
            cfdi_description: myCFDI?.description ?? (data.cfdi_description ?? null),
            supplier_bank_account_id: mySupplierBankAccount?.supplier_bank_account_id ?? (data.supplier_bank_account_id ?? null),
            supplier_account_alias: mySupplierBankAccount?.account_alias ?? (data.supplier_account_alias ?? null),
            supplier_bank_name: mySupplierBankAccount?.bank_name ?? (data.supplier_bank_name ?? null),
            supplier_bank_references: data.supplier_bank_references ?? (mySupplierBankAccount?.bank_references ?? null),
            supplier_account_number: mySupplierBankAccount?.account_number ?? (data.supplier_account_number ?? null),
            supplier_bank_phone_number: mySupplierBankAccount?.phone_number ?? (data.supplier_bank_phone_number ?? null),
            supplier_bank_card_number: mySupplierBankAccount?.card_number ?? (data.supplier_bank_card_number ?? null),
            supplier_bank_interbank_key: mySupplierBankAccount?.interbank_key ?? (data.supplier_bank_interbank_key ?? null),
            supplier_bank_swift_code: mySupplierBankAccount?.swift_code ?? (data.supplier_bank_swift_code ?? null),
            supplier_bank_currency_id: mySupplierBankAccount?.currency_id ?? (data.supplier_bank_currency_id ?? null),
            supplier_bank_currency_code: mySupplierBankAccount?.currency_code ?? (data.supplier_bank_currency_code ?? null),
            supplier_bank_currency_description: mySupplierBankAccount?.currency_description ?? (data.supplier_bank_currency_description ?? null),
            supplier_street: mySupplierLocation?.street ?? (data.supplier_street ?? null),
            supplier_city_id: mySupplierLocation?.city_id ?? (data.supplier_city_id ?? null),
            supplier_city_name: mySupplierLocation?.city_name ?? (data.supplier_city_name ?? null),
            supplier_state_id: mySupplierLocation?.state_id ?? (data.supplier_state_id ?? null),
            supplier_state_name: mySupplierLocation?.state_name ?? (data.supplier_state_name ?? null),
            supplier_state_abbr: mySupplierLocation?.state_abbr ?? (data.supplier_state_abbr ?? null),
            supplier_country_id: mySupplierLocation?.country_id ?? (data.supplier_country_id ?? null),
            supplier_country_code: mySupplierLocation?.country_code ?? (data.supplier_country_code ?? null),
            supplier_country_name: mySupplierLocation?.country_name ?? (data.supplier_country_name ?? null),
            supplier_postal_code: mySupplierLocation?.postal_code ?? (data.supplier_postal_code ?? null),
            supplier_language: mySupplierLocal?.language_code ?? "ES",
            company_bank_account_id: myCompanyBankAccount?.company_bank_account_id ?? (data.company_bank_account_id ?? null),
            company_account_alias: myCompanyBankAccount?.account_alias ?? (data.company_account_alias ?? null),
            company_bank_name: myCompanyBankAccount?.bank_name ?? (data.company_bank_name ?? null),
            company_bank_references: myCompanyBankAccount?.bank_references ?? (data.company_bank_references ?? null),
            company_account_number: myCompanyBankAccount?.account_number ?? (data.company_account_number ?? null),
            company_bank_phone_number: myCompanyBankAccount?.phone_number ?? (data.company_bank_phone_number ?? null),
            company_bank_card_number: myCompanyBankAccount?.card_number ?? (data.company_bank_card_number ?? null),
            company_bank_interbank_key: myCompanyBankAccount?.interbank_key ?? (data.company_bank_interbank_key ?? null),
            company_bank_swift_code: myCompanyBankAccount?.swift_code ?? (data.company_bank_swift_code ?? null),
            company_bank_currency_id: myCompanyBankAccount?.currency_id ?? (data.company_bank_currency_id ?? null),
            company_bank_currency_code: myCompanyBankAccount?.currency_code ?? (data.company_bank_currency_code ?? null),
            company_bank_currency_description: myCompanyBankAccount?.currency_description ?? (data.company_bank_currency_description ?? null),
            company_street: myCompanyLocation?.street ?? (data.company_street ?? null),
            company_city_id: myCompanyLocation?.city_id ?? (data.company_city_id ?? null),
            company_city_name: myCompanyLocation?.city_name ?? (data.company_city_name ?? null),
            company_state_id: myCompanyLocation?.state_id ?? (data.company_state_id ?? null),
            company_state_name: myCompanyLocation?.state_name ?? (data.company_state_name ?? null),
            company_state_abbr: myCompanyLocation?.state_abbr ?? (data.company_state_abbr ?? null),
            company_country_id: myCompanyLocation?.country_id ?? (data.company_country_id ?? null),
            company_country_name: myCompanyLocation?.country_code ?? (data.company_country_name ?? null),
            company_postal_code: myCompanyLocation?.postal_code ?? (data.company_postal_code ?? null),
            company_rfc: myCompanyLocal?.rfc ?? (data.company_rfc ?? null),
            currency_id: myCurrency?.currency_id ?? (data.currency_id ?? null),
            currency_code: myCurrency?.currency_code ?? (data.currency_code ?? null),
            currency_description: myCurrency?.currency_description ?? (data.currency_description ?? null),
            subtotal_tax_amount: data.subtotal_tax_amount ?? 0,
            total_tax_amount: data.total_tax_amount ?? 0,
            subtotal_retention_amount: data.subtotal_retention_amount ?? 0,
            total_retention_amount: data.total_retention_amount ?? 0,
            subtotal_amount: data.subtotal_amount ?? 0,
            total_amount: totalAmount,
            original_string_SAT: data.original_string_SAT ?? null,
            certificate_number_SAT: data.certificate_number_SAT ?? null,
            certificate_number_CFDI: data.certificate_number_CFDI ?? null,
            uuid: data.uuid ?? null,
            seal_SAT: data.seal_SAT ?? null,
            seal_CFDI: data.seal_CFDI ?? null,
            xml_file_id: data.xml_file_id ?? null,
            qr_file: data.qr_file ?? null,
            report_file_id: data.report_file_id ?? null,
            cancel_xml_file_id: data.cancel_xml_file_id ?? null,
            date_mail_send: data.date_mail_send ?? null,
            user_mail_send: data.user_mail_send ?? null,
            cancellation_date: data.cancellation_date ?? null,
            cancellation_reason: data.cancellation_reason ?? null,
            cancellation_response_code: data.cancellation_response_code ?? null,
            cancellation_reason_description: data.cancellation_reason_description ?? null,
            intermediary_account_alias: myIntermediaryBank?.account_alias ?? null,
            intermediary_bank_name: myIntermediaryBank?.bank_name ?? null,
            intermediary_bank_references: data.supplier_bank_references ?? (mySupplierBankAccount?.bank_references ?? null),
            intermediary_account_number: myIntermediaryBank?.account_number ?? null,
            intermediary_bank_phone_number: myIntermediaryBank?.phone_number ?? null,
            intermediary_bank_card_number: myIntermediaryBank?.card_number ?? null,
            intermediary_bank_interbank_key: myIntermediaryBank?.interbank_key ?? null,
            intermediary_bank_swift_code: myIntermediaryBank?.swift_code ?? null,
            intermediary_bank_currency_code: myIntermediaryBank?.currency_code ?? null,
            intermediary_bank_currency_description: myIntermediaryBank?.currency_description ?? null,
            paymentsdetails: sortedPaymentsDetails,
            exchange_rate: exchangeRate,
            advanceInvoices: myAdvanceInvoices,
            commission: data.commission ?? 0,
            commission_currency_id: commissionCurrency ? commissionCurrency.currency_id : null,
            commission_currency_code: commissionCurrency ? commissionCurrency.currency_code : null,
            commission_currency_description: commissionCurrency ? commissionCurrency.currency_description : null,
          }
          GenericPostResource(`/payments`, myData)
            .then(async (response) => {
              if (response.data.error) {
                Swal.fire({
                  customClass: { container: "swalfire" },
                  icon: "error",
                  confirmButtonColor: theme.palette.primary.main,
                  title: "Error",
                  html: `${response.data.error}${(response.data.details) != null ? '<br> <br>' + response.data.details : ""}`,
                });
                if (!response.data.data) {
                  setHasErrorPost((prev) => true);
                  setIsEdit(false);
                  setLoadingPost(false);
                  setValue("total_amount", 0);
                  setDialogConfirmApplyPayment(false);
                }
              }
              else {
                if (response.data.XML !== undefined && response.data.QR !== undefined) {
                  setValue("xml_file_id", response.data.XML)
                  setValue("qr_file", response.data.QR)
                  await GetFiles(response.data.payment_id, "Payments").then((responsefiles) => {
                    if (responsefiles && responsefiles.length > 0) {
                      for (let i = 0; i < responsefiles.length; i++) {
                        const element: File = responsefiles[i];
                        if (element.file_id === (((getValues && getValues("qr_file")) ?? response.data.QR))) {
                          setFiscalQr(() => element);
                        }
                        if (element.file_id === (((getValues && getValues("xml_file_id")) ?? response.data.XML))) {
                          setFiscalXML(() => element);
                        }
                      }
                    }
                  });
                }
                if (response.data.data) {
                  setValue("payment_id", response.data.data.payment_id);
                  setPaymentLocal(response.data.data);
                  await onGeneratePDF(response.data.data.payment_id);
                }
                else if (response.data) {
                  setValue("payment_id", response.data.payment_id)
                  setPaymentLocal(response.data);
                  await onGeneratePDF(response.data.payment_id);
                  await GenericPutResource(`/payments/${response.data.payment_id}`, { report_file_id: getValues("report_file_id") })
                }
                setLoadingPost(false);
                setDialogConfirmApplyPayment(false);
                Swal.fire({
                  customClass: { container: "swalfire" },
                  title: `${t("payments.info.stamped")}`,
                  confirmButtonColor: theme.palette.primary.main,
                  icon: "success",
                  allowOutsideClick: false
                });
              }
            })
            .catch(async (error) => {
              if (error.response.data.errorMessage) {
                await showSnackBar(t(error.response.data.errorMessage), "error");
              }
              else {
                showSnackBar(error.message, 'error');
              }
              setHasErrorPost((prev) => true);
              setIsEdit(false);
              setLoadingPost(false);
              setValue("total_amount", 0);
              setDialogConfirmApplyPayment(false)
            });
        }
      });
  }

  const getDataAndGeneratePDF = async (paymentId: number) => {
    try {
      const response = await GenericGetReport(`/payments/pdf/${paymentId}`, false);

      if (response.data.dataIssuingCompany.rpt_image) {
        const rptImageFile = await GenericGetResource(`/filessql/` + response.data.dataIssuingCompany.rpt_image);
        response.data.dataReceiptHeader.logoImage = rptImageFile?.data.data_file ?? undefined;
      }

      // if (response.data.dataPaymentHeader.qr_file) {
      //   const responseQR = await GetFileById(response.data.dataPaymentHeader.qr_file);
      //   const base64Part = responseQR?.dataURL.split(';base64,')[1];
      //   const newBase64 = `data:image/png;base64,${base64Part}`;
      //   response.data.dataPaymentHeader.fiscalQr = newBase64 ?? undefined;
      // }

      let pdfDoc = await generatePDF(response.data, parameters);
      return pdfDoc;
    } catch (error) {
      showSnackBar(t("generic.reports.PDF-generate-error"), "error");
    }
  };


  const onGeneratePDF = async (payment_id: number) => {
    const pdfDoc = await getDataAndGeneratePDF(payment_id);
    const fileId = await SavePdf("Payments", payment_id, getValues("payment_name"), pdfDoc);
    setValue("report_file_id", fileId);
  };

  const calculateBalance = async () => {
    let myLocalCompanyBankAccount = comboCompanyBankAccounts.find((item) => item.company_bank_account_id === getValues("company_bank_account_id"));
    if (myLocalCompanyBankAccount) {
      try {
        let totalAmountToPay = 0;

        // traer el monto que esta escrito
        if (getValues("total_amount")?.toString() !== '') {
          totalAmountToPay = parseFloat(getValues("total_amount")?.toString() ?? '0');
        }
        // get balance total de company
        const balance = myLocalCompanyBankAccount.balance;
        let calculatedBalance = 0;
        let total = 0;

        calculatedBalance = ((balance ?? 0) - totalAmountToPay);
        total = totalAmountToPay;

        if (exchangeRate === -1) {
          Swal.fire({
            customClass: { container: "swalfire" },
            title: `${t("salesinvoices.info.add-exchangeratehistory")}`,
            icon: "warning",
            confirmButtonColor: theme.palette.primary.main,
            allowOutsideClick: false
          });
          setRowsCompanyBalance(() => [{
            currency_id: companyBalance.currency_id,
            currency_code: companyBalance.currency_code,
            balance: companyBalance.balance,
            balancePay: 0,
            balanceFree: 0,
          }]);
        }
        else {
          setRowsCompanyBalance(() => [{
            currency_id: myLocalCompanyBankAccount?.currency_id ?? 0,
            currency_code: myLocalCompanyBankAccount?.currency_code ?? '',
            balance: balance ?? 0,
            balancePay: total ?? 0,
            balanceFree: calculatedBalance ?? 0,
          }]);
        }
      } catch (error) {
        console.error("Error calculating balance:", error);
      }
    }
    else {
      setRowsCompanyBalance(() => [{
        currency_id: 0,
        currency_code: '',
        balance: 0,
        balancePay: 0,
        balanceFree: 0,
      }]);
    }
  };

  useEffect(() => { }, [rowsCompanyBalance]);

  const onChangeTotals = async (myRows: readonly GridValidRowModel[], currencySupplierBankAccount?: string, myTypingExchangeRate?: number) => {
    trigger();
    setIsLoadingCurrenciesValues(true);
    let myExchangeRate: number | undefined;
    if (!currencySupplierBankAccount) {
      let mySupplierBankAccount = comboSupplierBankAccounts.find((item) => item.supplier_bank_account_id === (getValues("supplier_bank_account_id")));
      currencySupplierBankAccount = mySupplierBankAccount?.currency_code;
    }
    // si la cuenta bancaria del proveedor/compañia/myRows tienen USD traer tipo de cambio en el exchange rate
    let currencyCodeFilter = myRows?.find((element) => element.related_currency_code !== "MXN");
    let myCurrencyCompanyBankAccountId = getValues("company_bank_account_id");
    let myCurrencyCompanyBankAccount = comboCompanyBankAccounts.find((item) => item.company_bank_account_id === myCurrencyCompanyBankAccountId);
    if (!myTypingExchangeRate) {

      if (
        (((currencySupplierBankAccount !== undefined) && (currencySupplierBankAccount !== "MXN")) ||
          currencyCodeFilter ||
          ((myCurrencyCompanyBankAccount?.currency_code !== undefined) && (myCurrencyCompanyBankAccount?.currency_code !== "MXN"))) &&
        !hasExchangeRate
      ) {
        let currencyId = comboCurrencies.find((element: Currency) => element.currency_code !== "MXN")?.currency_id ?? 0;
        let date = new Date(getValues("payment_date") ?? new Date());
        date?.setDate(date.getDate() + 1);

        const currency = await GetExchangeRateFromCurrencyCode(currencyId, date);
        setExchangeRate(currency?.rate ?? 1);
        myExchangeRate = currency?.rate ?? 1;
        setHasExchangeRate(true);
      }
      else {
        if (!currencySupplierBankAccount && !myCurrencyCompanyBankAccount && !currencyCodeFilter) {
          setExchangeRate(1);
          myExchangeRate = 1;
          setHasExchangeRate(false);
        }
        else if ((currencySupplierBankAccount === "MXN" && myCurrencyCompanyBankAccount?.currency_code === "MXN") && (!currencyCodeFilter || !myRows.length)) {
          setExchangeRate(1);
          myExchangeRate = 1;
          setHasExchangeRate(false);
        }
        else {
          myExchangeRate = exchangeRate;
        }
      }
    }
    else {
      myExchangeRate = myTypingExchangeRate;
    }

    // Update totals
    if (myCurrencyCompanyBankAccount?.currency_code) {
      let myTotalAmount: number = 0;
      myRows.forEach((element) => {
        const amount = Number(element.amount_outstanding) || 0;
        let myOperation = GetOperatorToGetDivisa(myCurrencyCompanyBankAccount?.currency_code ?? '', element.related_currency_code);
        switch (myOperation) {
          case "multiply":
            myTotalAmount += amount * (myExchangeRate || 1);
            break;
          case "divide":
            myTotalAmount += amount / (myExchangeRate || 1);
            break;
          case "same":
            myTotalAmount += amount;
            break;
        }
      });
      myTotalAmount = parseFloat(Number(myTotalAmount).toFixed(2));

      const commission = Number(getValues("commission")) || 0;
      const commissionCurrencyId = getValues("commission_currency_id");

      if (commission && commissionCurrencyId) {
        const commissionCurrency = comboCurrencies.find((c: Currency) =>
          c.currency_id === commissionCurrencyId
        );

        if (commissionCurrency) {
          const commissionExchangeRate = exchangeRate;

          const operation = GetOperatorToGetDivisa(
            myCurrencyCompanyBankAccount.currency_code,
            commissionCurrency.currency_code
          );

          let convertedCommission = 0;

          switch (operation) {
            case "multiply":
              convertedCommission = commission * (commissionExchangeRate || 1);
              break;
            case "divide":
              convertedCommission = commission / (commissionExchangeRate || 1);
              break;
            case "same":
              convertedCommission = commission;
              break;
          }
          setCommissionParsed(convertedCommission);

          if (exchangeRate > 0) {
            setHasExchangeRate(true);
          }

          myTotalAmount += convertedCommission;
        }
      }

      setValue("selected_amount", myTotalAmount);
      let myTotalToPay = parseFloat(getValues("total_amount")?.toString() ?? "0")
      if (isNaN(myTotalToPay)) {
        myTotalToPay = 0;
      }
      setValue("difference_amount", parseFloat(Number(myTotalAmount - (getValues("total_amount") ?? 0)).toFixed(2) ?? 0));

      let myOperation = GetOperatorToGetDivisa(currencySupplierBankAccount ?? '', myCurrencyCompanyBankAccount.currency_code ?? '');
      switch (myOperation) {
        case "multiply":
          {
            let myValue = roundToFourDecimals((getValues("total_amount") ?? 0) * (myExchangeRate));
            setValue("total_amount_related", myValue);
            break;
          }
        case "divide":
          {
            let myValue = roundToFourDecimals((getValues("total_amount") ?? 0) / myExchangeRate);
            setValue("total_amount_related", myValue);
            break;
          }
        case "same":
          {
            let myValue = roundToFourDecimals((getValues("total_amount") ?? 0));
            setValue("total_amount_related", myValue);
            break;
          }
      }
    }
    else {
      setValue("difference_amount", 0);
      setValue("selected_amount", 0);
    }

    calculateBalance();
    setIsLoadingCurrenciesValues(false);
    setOpenBackDrop(false);
  }

  const ConcatBankReferencesFields = (myRows: readonly GridValidRowModel[] | undefined) => {
    if (!myRows) {
      setValue("supplier_bank_references", "");
      // setValue("intermediary_bank_references", "");
    }
    else {
      let mySupplierBankReferences = "";
      // let myIntermediaryBankReferences = "";

      for (let i = 0; i < myRows.length; i++) {
        const e: PaymentDetail = myRows[i];
        if (i === myRows.length - 1) {
          if (e.purchase_invoice_supplier_bank_references !== undefined && e.purchase_invoice_supplier_bank_references !== null) {
            mySupplierBankReferences += `${e.purchase_invoice_supplier_bank_references}`;
          }
          // if (e.purchase_invoice_intermediary_bank_references !== undefined && e.purchase_invoice_intermediary_bank_references !== null) {
          //   myIntermediaryBankReferences += `${e.purchase_invoice_intermediary_bank_references}`;
          // }
        } else if (e.purchase_invoice_supplier_bank_references) {
          if (e.purchase_invoice_supplier_bank_references !== undefined && e.purchase_invoice_supplier_bank_references !== null) {
            mySupplierBankReferences += `${e.purchase_invoice_supplier_bank_references}, `;
          }
          // if (e.purchase_invoice_intermediary_bank_references !== undefined && e.purchase_invoice_intermediary_bank_references !== null) {
          //   myIntermediaryBankReferences += `${e.purchase_invoice_intermediary_bank_references}, `;
          // }
        }
      }
      setValue("supplier_bank_references", mySupplierBankReferences ?? "");
      // setValue("intermediary_bank_references", myIntermediaryBankReferences ?? "");
    }
  }

  const validateCurrencyConversion = () => {
    return hasExchangeRate && currencySupplier && getValues("company_bank_account_id") && (currencySupplier?.currency_code !== (comboCompanyBankAccounts.find((item) => item.company_bank_account_id === (getValues("company_bank_account_id"))))?.currency_code);
  }

  useEffect(() => {
    let myPromises = [
      GenericGetResource(`/suppliers/${supplier_id}`),
      GenericGetResource(`/supplierbankaccounts/bysupplierid/${supplier_id}`),
      GenericGetResourceGeneric("/companies", "/gcompanies"),
      GenericGetResourceGeneric("/companybankaccounts", "/gcompanybankaccounts"),
      GenericGetResource(`/paymentmethods`),
      GenericGetResource(`/currencies`),
      GenericGetResource(`/supplierlocations/bysupplierid/${supplier_id}`),
      GenericGetResource("/bankaccounts")
    ];

    Promise.all(myPromises)
      .then(async (responses) => {
        responses[0] && setMySupplierLocal(responses[0].data);
        responses[1] && setComboSupplierBankAccounts(responses[1].data.data);
        responses[2] && setMyCompanyLocal(responses[2].data.data[0]);
        let myComboCompanyBankAccounts = responses[3].data.data.filter((element: CompanyBankAccount) => element.company_id === 1)
        await responses[3] && setComboCompanyBankAccounts(myComboCompanyBankAccounts);
        responses[4] && setComboPaymentMethods(responses[4].data.data);
        responses[5] && setComboCurrencies(responses[5].data.data);
        responses[5] && setComboCommissionCurrencies(responses[5].data.data);
        responses[6] && setComboSuppliersLocations(responses[6].data.data);
        responses[7] && setComboBankAccountsGeneral(responses[7].data.data);
        setMySelectedRows(selectedRows ?? []);

        let myPermissions = [
          GetResourceByUrl(`/payments`),
        ];

        Promise.all(myPermissions)
          .then((responsesPermissions) => {
            responsesPermissions[0] && setResourceFiscalSignature(responsesPermissions[0]);
          });
        if (selectedRows) {
          let defaultFinalBankAccount = selectedRows.find((element) => element.intermediary_account_alias !== undefined && element.intermediary_account_alias !== null)

          if (defaultFinalBankAccount && responses[7] && responses[7].data.data && responses[7].data.data.length > 0) {
            let myBankAccount = responses[7].data.data.find((element: BankAccount) => element.account_alias === defaultFinalBankAccount?.intermediary_account_alias)
            setDefaultBankAccountFinal(myBankAccount);
            setValue("intermediary_bank_account_id", myBankAccount?.bank_account_id);
            await reset({ intermediary_bank_account_id: myBankAccount?.bank_account_id }, { keepValues: true });
          }
        }

        let myDefaultCompanyBankAccount = responses[3].data.data.find((item: CompanyBankAccount) => item.company_bank_account_id === responses[2].data.data[0].primary_bank_account);
        setDefaultCompanyBankAccount(myDefaultCompanyBankAccount);
        setCompanyBalance({
          balance: myDefaultCompanyBankAccount?.balance ?? 0,
          currency_id: myDefaultCompanyBankAccount?.currency_id ?? 0,
          currency_code: myDefaultCompanyBankAccount?.currency_code ?? "",
        });

        let myDefaultSupplierBankAccount: SupplierBankAccount;
        // traer el id de la cuenta bancaria de la primera que se selecciono
        myDefaultSupplierBankAccount = await responses[1].data.data.find((item: SupplierBankAccount) => item.supplier_bank_account_id === (selectedRows && selectedRows[0].supplier_bank_account_id));
        if (!myDefaultSupplierBankAccount) {
          myDefaultSupplierBankAccount = await responses[1].data.data.find((item: SupplierBankAccount) => item.supplier_bank_account_id === responses[0].data.primary_bank_account);
        }
        setDefaultSupplierBankAccount((prev) => myDefaultSupplierBankAccount);
        setValue("supplier_bank_account_id", myDefaultSupplierBankAccount?.supplier_bank_account_id);
        let myCurrency: Currency = {
          currency_id: myDefaultSupplierBankAccount.currency_id ?? 0,
          currency_code: myDefaultSupplierBankAccount?.currency_code ?? '',
          currency_description: myDefaultSupplierBankAccount?.currency_description ?? '',
          currency_symbol: myDefaultSupplierBankAccount.currency_symbol ?? undefined,
        }

        if (!currencySupplier?.currency_code) {
          await setCurrencySupplier((prev) => myCurrency);
        }

        let mySupplierLocations: SupplierLocation[] = responses[6].data.data;
        let myDefaultSupplierLocation;
        if (businessName) {
          myDefaultSupplierLocation = mySupplierLocations.find((item) => item.business_name === businessName);
        }
        else {
          myDefaultSupplierLocation = mySupplierLocations.find((item) => item.fiscal_address === true);
        }
        setDefaultSupplierLocation(myDefaultSupplierLocation);
        setValue("supplier_business_name", myDefaultSupplierLocation?.business_name);

        let myDefaultPaymentMethod = responses[4].data.data.find((item: PaymentMethod) => item.payment_method_id === responses[0].data.default_payment_method_id)
        setDefaultPaymentMethod(myDefaultPaymentMethod);

        reset({
          company_bank_account_id: myDefaultCompanyBankAccount && myDefaultCompanyBankAccount.company_bank_account_id,
          supplier_bank_account_id: myDefaultSupplierBankAccount && myDefaultSupplierBankAccount.supplier_bank_account_id,
          payment_method_id: myDefaultPaymentMethod && myDefaultPaymentMethod.payment_method_id,
          payment_date: new Date(),
        }, { keepValues: true });

        showSnackBar(t("payments.info.apply-payment-filter"), "info");
        setPreSelectedRows((prev) => selectedRows?.map((row) => {
          if (row.payment_detail_id && row.payment_name === null) {
            return row.payment_detail_id;
          }
        }));
        setParameters(await fetchParameters());
        ConcatBankReferencesFields(selectedRows);
        setDataLoaded(true);
      })
      .catch((error) => {
        showSnackBar(error.message, 'error');
      });

  }, []);

  useEffect(() => {
    if (comboCurrencies.length && (currencySupplier?.currency_id !== undefined) && currencySupplier?.currency_id > 0 && !isLoadedExchangeRate) {
      setOpenBackDrop(true);
      new Promise(async () => await onChangeTotals(mySelectedRows, currencySupplier?.currency_code))
        .finally(() => {
          setIsLoadedExchangeRate(true);
          setOpenBackDrop(false);
        });
    }
  }, [comboCurrencies, currencySupplier]);

  function roundToFourDecimals(num: number): number {
    return Math.round(num * 10000) / 10000;
  }

  return (
    <>
      <Header
        size="no_title"
        child={
          <>
            {!dataLoaded &&
              <Skeleton variant="rectangular" height={50} />
            }
            {dataLoaded &&
              <div className="d-flex flex-column justify-content-between align-items-center">
                {rowsCompanyBalance.length &&
                  <TableCurrencyBankAccounts
                    rowsCompanyBalance={rowsCompanyBalance}
                  />
                }
                <HeaderPayment
                  comboCompanyBankAccounts={comboCompanyBankAccounts}
                  control={control}
                  currencySupplier={currencySupplier}
                  defaultCompanyBankAccount={defaultCompanyBankAccount}
                  errors={errors}
                  getValues={getValues}
                  hasAdvanceSalesInvoice={hasAdvanceSalesInvoice}
                  isEdit={isEdit}
                  isLoadingCurrenciesValues={isLoadingCurrenciesValues}
                  loadingPost={loadingPost}
                  mySelectedRows={mySelectedRows}
                  onChangeTotals={onChangeTotals}
                  resourceFiscalSignature={resourceFiscalSignature}
                  setClickedButtonGoBack={setClickedButtonGoBack}
                  setDefaultCompanyBankAccount={setDefaultCompanyBankAccount}
                  setDialogConfirmApplyPayment={setDialogConfirmApplyPayment}
                  setDialogPayment={setDialogPayment}
                  showSnackBar={showSnackBar}
                  setSelectedRows={setSelectedRows}
                  trigger={trigger}
                  commissionParsed={commissionParsed}
                />
              </div>
            }
          </>
        }
      />
      {!dataLoaded && <Skeleton variant="rectangular" height={"70vh"} />}
      {dataLoaded &&
        <>
          <Box sx={{ minWidth: 1250 }} className="d-flex flex-column my-2 w-100">
            <PaymentForm
              comboBankAccountsGeneral={comboBankAccountsGeneral}
              comboCommissionCurrencies={comboCommissionCurrencies}
              comboCompanyBankAccounts={comboCompanyBankAccounts}
              comboPaymentMethods={comboPaymentMethods}
              comboSupplierBankAccounts={comboSupplierBankAccounts}
              comboSuppliersLocations={comboSuppliersLocations}
              control={control}
              currencySupplier={currencySupplier}
              defaultBankAccountFinal={defaultBankAccountFinal}
              defaultPaymentMethod={defaultPaymentMethod}
              defaultSupplierBankAccount={defaultSupplierBankAccount}
              defaultSupplierLocation={defaultSupplierLocation}
              errors={errors}
              exchangeRate={exchangeRate}
              getValues={getValues}
              handleSubmit={handleSubmit}
              hasAdvanceSalesInvoice={hasAdvanceSalesInvoice}
              hasExchangeRate={hasExchangeRate}
              isEdit={isEdit}
              isLoadingCurrenciesValues={isLoadingCurrenciesValues}
              mySelectedRows={mySelectedRows}
              mySupplierLocal={mySupplierLocal}
              onChangeTotals={onChangeTotals}
              onSubmit={onSubmit}
              setCommissionCurrency={setCommissionCurrency}
              setCurrencySupplier={setCurrencySupplier}
              setDefaultBankAccountFinal={setDefaultBankAccountFinal}
              setDefaultSupplierBankAccount={setDefaultSupplierBankAccount}
              setDefaultSupplierLocation={setDefaultSupplierLocation}
              setExchangeRate={setExchangeRate}
              setValue={setValue}
              trigger={trigger}
              validateCurrencyConversion={validateCurrencyConversion}
              hasCommissionAmount={hasCommissionAmount}
              setHasCommissionAmount={setHasCommissionAmount}
              showSnackBar={showSnackBar}
              reset={reset}
              setMyConsecutive={setMyConsecutive}
            />
            <div className="mt-2">
              <DialogPayments
                Details={
                  <TableApplyPayment
                    rows={rows.filter(row => row.is_authorized !== null && row.is_authorized !== undefined && row.is_authorized !== '' && row.is_authorized)}
                    getValues={getValues}
                    setSelectedRows={setMySelectedRows}
                    onChangeTotals={onChangeTotals}
                    preSelectedRows={preSelectedRows}
                    setPreSelectedRows={setPreSelectedRows}
                    loadingPost={loadingPost}
                    isEdit={isEdit}
                    hasErrorPost={hasErrorPost}
                    isLoadingCurrenciesValues={isLoadingCurrenciesValues}
                    myParentPreferences={myParentPreferences}
                    myParentColumns={myParentColumns}
                  />
                }
                Stamping={
                  <StampingPayment
                    paymentLocal={paymentLocal}
                    setPaymentLocal={setPaymentLocal}
                    isEdit={(paymentLocal?.payment_id && paymentLocal.payment_id != 0) ? false : true}
                  />
                }
              />
            </div>
            <DialogEntity
              open={dialogConfirmApplyPayment}
              title={<Header title={t("payments.title-view")} />}
              maxWidth={"sm"}
              fullWidth
              content={
                <ConfrimDialogPayment
                  getValues={getValues}
                  isEdit={isEdit}
                  isLoadingCurrenciesValues={isLoadingCurrenciesValues}
                  loadingPost={loadingPost}
                  onPost={onPost}
                  resourceFiscalSignature={resourceFiscalSignature}
                  setDialogConfirmApplyPayment={setDialogConfirmApplyPayment}
                  hasPositiveDifference={hasPositiveDifference}
                  hasCommissionAmount={hasCommissionAmount}
                />
              }
            />
          </Box>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openBackDrop}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <SnackbarComponent />
        </>
      }
    </>
  )

}